import styled from "styled-components";

export const ButtonContainer = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
`;
